<template>
  <div>
    <h3>
      Puno hvala na izdvojenom vremenu i trudu da popunite Prijavu za učlanjenje
      u I MI Boke. Izvinite ako je popunjavanje Prijave bilo naporno, potrebni
      su nam mnogi podaci da bismo mogli da pružimo adekvatnu podršku. Bićemo
      slobodni da Vas kontaktiramo ukoliko nam neki od Vaših odgovora nisu
      jasni. Obavjestićemo Vas čim odobrimo Vaš prijem u članstvo I MI Boke.
      Nadamo se skoroj uspješnoj saradnji na obostrano zadovoljstvo. Budite
      slobodni da nas
      <a href="https://imiboke.me/contact-us/" target="_blank">kontaktirate</a>
      za sve dodatne informacije.
    </h3>
  </div>
</template>

<script></script>
